<template>
  <b-form-group :label="label"
                :invalid-feedback="errorTxt"
                :state="state">
    <div class="bs-component">
      <ul class="list-group">
        <draggable v-model="inputVal" :state="state" :readonly="readonly">
          <li class="list-group-item" v-for="(item, index) in inputVal" :key="'op'+index" style="cursor: move">
            <i class="fa fa-angle-right"></i>
            <b>{{ item.proxy }} </b>
            &nbsp;
            <span v-if="item.inbound" class="badge badge-success">{{ $t('inboundEnabled') }}</span>
            <span v-else class="badge badge-danger">{{ $t('inboundDisabled') }}</span>
            &nbsp;
            <span v-if="item.outbound" class="badge badge-success">{{ $t('outboundEnabled') }}</span>
            <span v-else class="badge badge-danger">{{ $t('outboundDisabled') }}</span>
            <div class="pull-right" style="margin-top: -5px; margin-right: -15px;">
              <button type="button" class="btn btn-sm btn-info mr-1">
                <i class="fa fa-arrows-v mr-0"></i>
              </button>
              <button @click="removeItem(index)" type="button" class="btn btn-sm btn-danger mr-1">
                <font-awesome-icon icon="trash"/>
              </button>
            </div>
          </li>
        </draggable>
      </ul>
    </div>
    <div class='input-group mb-1'>
      <input type="text" class="form-control" v-model="newItem.proxy" :placeholder="$t('newItemKey')"
             v-on:keyup="newItemEnter"/>
      &nbsp;
      <b-checkbox class="mt-2" v-model="newItem.inbound"/>
      <label class="mt-2 mr-1">{{ $t('inbound') }}</label>
      &nbsp;
      <b-checkbox class="mt-2" v-model="newItem.outbound"/>
      <label class="mt-2 mr-1">{{ $t('outbound') }}</label>
      &nbsp;
      <div class='input-group-append'>
        <button type="button" class="btn btn-sm btn-success" @click="addNewItem">{{ $t('create') }}</button>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {draggable},
  props: ['model', 'attribute', 'label', 'type', 'placeholder', 'errors', 'readonly', 'errorOnly'],
  data() {
    return {
      inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
      state: null,
      errorTxt: '',
      newItem: {
        proxy: null,
        inbound: false,
        outbound: false,
      },
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        this.inputVal = val[this.attribute];
      }, deep: true
    },
    inputVal(val) {
      this.state = null;
      this.errorTxt = '';
      this.model[this.attribute] = val;
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
            return;
          }
        });
      }
      if (!this.errorOnly) {
        this.state = !hasErr;
      }
    }
  },
  methods: {
    validate() {
      let regex = new RegExp(`^([0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3})(:[0-9]+)?$`);
      return regex.test(this.newItem.proxy)
    },
    addNewItem: function () {
      let model = this.model[this.attribute];
      if (model == null) {
        model = [];
      }
      if (this.newItem && this.newItem.proxy) {
        if (!this.validate()) {
          this.$swal({
            text: 'Invalid proxy',
            icon: 'error'
          })
          return;
        }
        let proxy = model.find(m => m.proxy === this.newItem.proxy);
        if (!proxy) {
          this.model[this.attribute].push(this.newItem);
        }
        this.newItem = {proxy: null, inbound: false, outbound: false};
      }
      this.model[this.attribute] = null;
      this.model[this.attribute] = model;
    },
    newItemEnter: function (e) {
      if (e.keyCode === 13) {
        this.addNewItem();
      }
    },
    removeItem: function (index) {
      if (this.model[this.attribute] && this.model[this.attribute].length) {
        this.model[this.attribute].splice(index, 1);
      }
    }
  },
  i18n: {
    messages: {
      en: {
        newItemKey: 'Proxy',
      },
      vi: {
        newItemKey: 'Proxy',
      }
    }
  },
}
</script>